const columnDataProjectNum = [
  {
    dataField: 'nomProekta',
    caption: 'Номер проекта',
    dataType: 'string'
  }
];
export default columnDataProjectNum;
